import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axioInstance from "../../../../../../../../../custom_utilities/AxiosInstance/axiosInstance";
import { url_store_package_deltaupgrade } from "../../../../../../../../../custom_utilities/api_services";
import boltIcon from "../../../../../../../../../utilities/images/package_mastery_upgrade/icon-bolt.svg";
import featureIcon from "../../../../../../../../../utilities/images/package_mastery_upgrade/icon-feature.svg";
import avatarOne from "../../../../../../../../../utilities/images/package_mastery_upgrade/avatar-1.png";
import avatarTwo from "../../../../../../../../../utilities/images/package_mastery_upgrade/avatar-2.png";
import avatarThree from "../../../../../../../../../utilities/images/package_mastery_upgrade/avatar-3.png";
import StoreMasteryUpgradeModal from "./StoreMasteryUpgradeModal";
import "./StoreMasteryUpgrade.scss";

const FALLBACK_AVATARS = [avatarOne, avatarTwo, avatarThree];

const formatRupee = (value) => {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return "";
  const rounded = Number.isInteger(amount) ? amount : Math.round(amount);
  return `₹${rounded.toLocaleString("en-IN")}`;
};

const StoreMasteryUpgrade = ({ packageData }) => {
  const history = useHistory();
  const banner = packageData?.package_upgrades;
  const offer = banner?.offer || {};
  const masteryId = offer.upgrade_package_id;
  const [upgradePay, setUpgradePay] = useState(null);
  const [popupOpen, setPopupOpen] = useState(false);
  const features = Array.isArray(banner?.missing_features)
    ? banner.missing_features.filter(Boolean)
    : [];
  const socialText = String(offer.buyers_animation?.text || "").trim();

  useEffect(() => {
    if (!masteryId || Number(banner?.show_upgrade_banner) !== 1) {
      setUpgradePay(null);
      return undefined;
    }

    let cancelled = false;
    setUpgradePay(null);
    axioInstance
      .get(`${url_store_package_deltaupgrade}?package_id=${masteryId}`)
      .then((response) => {
        if (cancelled) return;
        const quote = response?.data?.data;
        if (quote?.show_upgrade !== 1) return;
        const payload = quote.deltaupgrade_payload || {};
        const pay = Number(payload.delta_pay_rounded ?? quote.upgrade_card?.pay_amount);
        if (Number.isFinite(pay)) setUpgradePay(pay);
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [masteryId, banner?.show_upgrade_banner]);

  if (Number(banner?.show_upgrade_banner) !== 1 || !masteryId) return null;

  const listPrice = Number(offer.amount || 0);
  const catalogPay = Math.max(0, listPrice - Number(offer.discount || 0));
  const payPrice =
    upgradePay != null && upgradePay < catalogPay ? upgradePay : catalogPay;
  const save = Math.max(0, Math.round(listPrice - payPrice));

  return (
    <section className="mastery-upgrade">
      <div className="mastery-upgrade__pitch">
        <div className="mastery-upgrade__intro">
          <div className="mastery-upgrade__title-row">
            <span className="mastery-upgrade__bolt">
              <img src={boltIcon} alt="" />
            </span>
            <h3>{banner.title}</h3>
          </div>
          {banner.description ? <p>{banner.description}</p> : null}
        </div>
        {features.length ? (
          <ul className="mastery-upgrade__features">
            {features.map((feature) => (
              <li key={feature}>
                <span className="mastery-upgrade__lock">
                  <img src={featureIcon} alt="" />
                </span>
                <span>{feature}</span>
              </li>
            ))}
          </ul>
        ) : null}
        {socialText ? (
          <div className="mastery-upgrade__social">
            <span className="mastery-upgrade__avatars">
              {FALLBACK_AVATARS.map((avatar) => (
                <img key={avatar} src={avatar} alt="" />
              ))}
            </span>
            <span dangerouslySetInnerHTML={{ __html: socialText }} />
          </div>
        ) : null}
      </div>

      <div className="mastery-upgrade__offer">
        <div className="mastery-upgrade__offer-copy">
          <div className="mastery-upgrade__tags">
            {offer.tag ? <span className="mastery-upgrade__badge">{offer.tag}</span> : <span />}
            {offer.sub_tag ? (
              <span className="mastery-upgrade__limited">{offer.sub_tag}</span>
            ) : null}
          </div>
          {offer.main_text ? <p>{offer.main_text}</p> : null}
          <div className="mastery-upgrade__price-row">
            <strong>{formatRupee(payPrice)}</strong>
            {save > 0 ? <s>{formatRupee(listPrice)}</s> : null}
            {save > 0 ? (
              <span className="mastery-upgrade__save">Save {formatRupee(save)}</span>
            ) : null}
          </div>
        </div>
        <button
          type="button"
          className="mastery-upgrade__cta"
          onClick={() => setPopupOpen(true)}
        >
          {offer.button_text || "Upgrade to Mastery"}
        </button>
      </div>
      <StoreMasteryUpgradeModal
        open={popupOpen}
        onClose={() => setPopupOpen(false)}
        onUpgrade={() => {
          setPopupOpen(false);
          history.push(`/package/${masteryId}`);
        }}
        currentName={packageData?.PackageInstallmentDetails?.package_name}
        offer={offer}
        features={features}
        payPrice={payPrice}
        listPrice={listPrice}
      />
    </section>
  );
};

export default StoreMasteryUpgrade;
